import { render, staticRenderFns } from "./userActivityDetail.vue?vue&type=template&id=28e7b169&scoped=true"
import script from "./userActivityDetail.vue?vue&type=script&lang=js"
export * from "./userActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./userActivityDetail.vue?vue&type=style&index=0&id=28e7b169&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e7b169",
  null
  
)

export default component.exports